import * as React from "react";
const SvgNoFlightPlansAdded = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 225.048 122.798",
	preserveAspectRatio: "xMidYMid meet",
	...props
}, /* @__PURE__ */ React.createElement("g", { transform: "translate(.001)" }, /* @__PURE__ */ React.createElement("path", {
	fill: "#939d9e",
	d: "m129.826 121.295-3.262-1.378-2.24-16.371H94.486l-2.429 16.3-2.922 1.461a.694.694 0 0 0 .31 1.314h40.11a.694.694 0 0 0 .269-1.333Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#c9cac8",
	d: "M182.842 105.726H36.291a2.9 2.9 0 0 1-2.9-2.9V82.157h152.348v20.666a2.9 2.9 0 0 1-2.9 2.9Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#7f8688",
	d: "M185.892 91.924H33.259V3.5a3.5 3.5 0 0 1 3.5-3.5h145.632a3.5 3.5 0 0 1 3.5 3.5Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#fff",
	d: "M176.777 6.418h-134.4a2.7 2.7 0 0 0-2.7 2.7v73.691a2.7 2.7 0 0 0 2.7 2.7h134.4a2.7 2.7 0 0 0 2.7-2.7V9.117a2.7 2.7 0 0 0-2.7-2.7Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#f0f0f0",
	d: "M66.199 6.418v79.089H42.375a2.7 2.7 0 0 1-2.7-2.7V9.117a2.7 2.7 0 0 1 2.7-2.7Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#ffb6b6",
	d: "M46.545 46.371a1.88 1.88 0 0 0-2.3 1.745l-6.413 1.891 2.655 2.241 5.683-2.139a1.891 1.891 0 0 0 .372-3.738Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#0d0c0c",
	d: "M20.635 60.599a2.675 2.675 0 0 1-.852-5.209l12.995-4.387 10.137-3.693 1.244 4.354-8.948 5.9-14.015 2.979a2.7 2.7 0 0 1-.561.056"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#ffb6b6",
	d: "M28.766 120.582h1.824l.868-7.037h-2.693Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#2f2e41",
	d: "M28.301 119.988h3.593a2.29 2.29 0 0 1 2.29 2.29v.075h-5.883Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#ffb6b6",
	d: "M14.777 120.582h1.824l.868-7.037h-2.692Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#2f2e41",
	d: "M14.312 119.988h3.593a2.29 2.29 0 0 1 2.29 2.29v.074h-5.883Zm.447-41.618a9.8 9.8 0 0 0-.521 6.166l-.521 34.909h4.007l2.243-19.2 3.721-12.65 4.018 9.822v20.474l3.869-.231 2.083-21.728-2.381-15.478Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#0d0c0c",
	d: "m29.418 51.21-3.423-1.042-.893-1.786h-4.4l-1.11 1.935s-4.465 1.637-4.614 9.525-.744 20.538-.744 20.538l17.6 2.51Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#ffb6b6",
	d: "M34.472 81.477a1.88 1.88 0 0 0-1.23-2.61l-.516-6.666-2.744 2.131.911 6a1.891 1.891 0 0 0 3.579 1.141Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#0d0c0c",
	d: "m29.79 78.041-3.907-9.979V53.734a2.675 2.675 0 0 1 5.331-.31l1.589 13.623 1.5 10.682Z"
}), /* @__PURE__ */ React.createElement("circle", {
	cx: 4.394,
	cy: 4.394,
	r: 4.394,
	fill: "#ffb9b9",
	transform: "translate(19.354 37.278)"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#2f2e41",
	d: "M24.032 40.336c-.206.264-.487.5-.533.834a4 4 0 0 0 .084.736.98.98 0 0 1-.918.983 1.1 1.1 0 0 0-.7-.4.65.65 0 0 0-.666.385c-.13.369.172.743.22 1.131a2.3 2.3 0 0 1-.137.843 7 7 0 0 1-.336 1.331 1.07 1.07 0 0 1-1.079.681 1.09 1.09 0 0 1-.74-.814c-.106-.371-.1-.764-.178-1.143-.249-1.229-1.306-2.139-1.721-3.322a4.51 4.51 0 0 1 1.208-4.42 3.6 3.6 0 0 1 1.676-1.085 15 15 0 0 1 2.115-.124 15 15 0 0 0 2.192-.58 3.04 3.04 0 0 1 2.214.094 14 14 0 0 1 1.232.991 2.6 2.6 0 0 0 1.7.454l-.718.314a2.3 2.3 0 0 0 .968.53 1.67 1.67 0 0 1-1.031.362 1.18 1.18 0 0 0 .742.571 3.4 3.4 0 0 1-1.725.461c-.294-.028-.575-.133-.865-.186a5.1 5.1 0 0 0-1.872.123c-.324.062-.723.122-.887.434-.137.257-.032.547-.245.816"
}), /* @__PURE__ */ React.createElement("circle", {
	cx: 7.009,
	cy: 7.009,
	r: 7.009,
	fill: "#00ad83",
	transform: "translate(45.929 38.953)"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#fff",
	d: "M57.144 45.962h-3.785v-3.785h-.841v3.785h-3.785v.841h3.785v3.785h.841v-3.785h3.785Zm55.484-30.294a.816.816 0 0 0-.815.815v13.651a.816.816 0 0 0 .815.815h55.034a.816.816 0 0 0 .815-.815V16.483a.816.816 0 0 0-.815-.815Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#e6e6e6",
	d: "M112.628 15.668a.816.816 0 0 0-.815.815v13.651a.816.816 0 0 0 .815.815h55.034a.816.816 0 0 0 .815-.815V16.483a.816.816 0 0 0-.815-.815Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#fff",
	d: "M112.73 30.033h54.829V16.585H112.73Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#e4e4e4",
	d: "M118.964 20.456a.714.714 0 1 0 0 1.427h42.36a.714.714 0 0 0 0-1.427Zm0 4.28a.714.714 0 0 0 0 1.427h42.36a.714.714 0 1 0 0-1.427z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#fff",
	d: "M74.358 38.832a.816.816 0 0 0-.815.815v13.651a.816.816 0 0 0 .815.815h55.034a.816.816 0 0 0 .815-.815V39.647a.816.816 0 0 0-.815-.815Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#e6e6e6",
	d: "M74.358 38.832a.816.816 0 0 0-.815.815v13.651a.816.816 0 0 0 .815.815h55.034a.816.816 0 0 0 .815-.815V39.647a.816.816 0 0 0-.815-.815Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#fff",
	d: "M74.46 53.197h54.829V39.749H74.46Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#e4e4e4",
	d: "M80.694 43.619a.714.714 0 1 0 0 1.427h42.36a.714.714 0 1 0 0-1.427Zm0 4.28a.714.714 0 0 0 0 1.427h42.36a.714.714 0 1 0 0-1.427z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#ffb7b7",
	d: "M141.44 75.471a1.687 1.687 0 0 0 1.433-2.153l4.877-3.484-2.907-1.119-4.186 3.48a1.7 1.7 0 0 0 .782 3.276Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#3f3d56",
	d: "m144.149 73.176-1.618-2.764.034-.039 6.528-7.432 5.069-8.644 4.4.561.065 1.33-.013.02-6.993 10.512-.008.006Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#ffb7b7",
	d: "M165.716 119.938h-2.489l-1.184-9.6h3.674Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#2f2e41",
	d: "M166.351 122.352h-8.026v-.1a3.124 3.124 0 0 1 3.124-3.124h4.9Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#ffb7b7",
	d: "m144.294 119.854-2.421-.578 1.078-9.613 3.573.853Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#2f2e41",
	d: "m144.351 122.351-7.806-1.864.024-.1a3.124 3.124 0 0 1 3.764-2.313l4.768 1.138Zm9.617-72.443v-4.19a5.615 5.615 0 1 1 11.229 0v4.19a.755.755 0 0 1-.754.754h-9.72a.755.755 0 0 1-.755-.754"
}), /* @__PURE__ */ React.createElement("circle", {
	cx: 4.116,
	cy: 4.116,
	r: 4.116,
	fill: "#ffb7b7",
	transform: "translate(154.081 42.366)"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#2f2e41",
	d: "M152.64 46.054a4.446 4.446 0 0 1 4.441-4.441h.838a4.446 4.446 0 0 1 4.441 4.441v.084h-1.771l-.6-1.691-.121 1.691h-.915l-.3-.853-.061.853h-5.944Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#3f3d56",
	d: "m160.598 68.208-10.481-.4-.586-6.857a4 4 0 0 1-.022-3.2 3.2 3.2 0 0 1 1.77-1.53l2.293-2.77a3.12 3.12 0 0 1 2.424-1.13l5.958.041c.144-.086 1.015-.529 2.733.216 1.864.808 1.431 3.614 1.426 3.642v.026l-.02.017-3.964 3.338Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#0d0c0c",
	d: "m150.201 67.072-4.957 9.038-3.759 41.121 4.247 1.3 7.517-32.167 8.724 31.254 5.09.127-3.466-36.067-3.029-13.964Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#fff",
	d: "M118.116 60.372a.816.816 0 0 0-1.027.524l-4.21 12.986a.816.816 0 0 0 .524 1.027l52.351 16.971a.816.816 0 0 0 1.027-.524l4.21-12.986a.816.816 0 0 0-.524-1.027Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#e6e6e6",
	d: "M118.116 60.372a.816.816 0 0 0-1.027.524l-4.21 12.986a.816.816 0 0 0 .524 1.027l52.351 16.971a.816.816 0 0 0 1.027-.524l4.21-12.986a.816.816 0 0 0-.524-1.027Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#fff",
	d: "m113.783 74.069 52.158 16.908 4.147-12.792-52.158-16.908Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#0d0c0c",
	d: "M122.666 66.881a.713.713 0 0 0-.44 1.357l40.3 13.062a.713.713 0 0 0 .441-1.357Zm-1.319 4.071a.713.713 0 0 0-.44 1.357l40.3 13.063a.713.713 0 0 0 .443-1.356Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#ffb7b7",
	d: "M163.445 81.704a1.687 1.687 0 0 0-.089-2.585l1.935-5.673-3.015.783-1.376 5.267a1.7 1.7 0 0 0 2.544 2.207Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#3f3d56",
	d: "m164.31 78.262-2.925-1.3.983-9.9-.915-9.978 3.9-2.108.828 1.044v.024l.439 12.618v.01Z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#ccc",
	d: "M224.705 122.799H71.748a.35.35 0 0 1-.344-.254.342.342 0 0 1 .331-.43h152.942a.36.36 0 0 1 .362.267.342.342 0 0 1-.334.416Zm-173.224 0H.354a.35.35 0 0 1-.344-.254.342.342 0 0 1 .331-.43h51.113a.36.36 0 0 1 .362.267.342.342 0 0 1-.334.416Z"
})));
export default SvgNoFlightPlansAdded;
